import { render } from "./WaitResetPage.vue?vue&type=template&id=7184a5f8&ts=true"
import script from "./WaitResetPage.vue?vue&type=script&lang=ts"
export * from "./WaitResetPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__